import { rnctMainnetAddress, rnctRinkebyAddress } from '../configs';



export default function getRnctAddress(chainNumber) {
  if (chainNumber === 1)
    return rnctMainnetAddress;
  if (chainNumber === 4)
    return rnctRinkebyAddress;
  return null;
}
